import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-322c1e82")

_pushScopeId("data-v-322c1e82")
const _hoisted_1 = { class: "p-pb-4 p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = { class: "p-m-0" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "p-d-none p-d-md-block p-field p-col" }
const _hoisted_8 = { class: "p-d-flex p-ai-center p-flex-wrap" }
const _hoisted_9 = { class: "p-ml-auto p-mr-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "p-d-none p-d-md-block",
  style: {"overflow-x":"auto"}
}
const _hoisted_15 = { class: "p-text-nowrap p-text-truncate" }
const _hoisted_16 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_17 = {
  key: 1,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_18 = { class: "p-d-block p-d-md-none p-grid" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EditWorkspace = _resolveComponent("EditWorkspace")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("workspace.label.home.welcome")), 1),
      _createVNode(_component_Button, {
        icon: "pi pi-plus",
        label: _ctx.$matchMedia.desktop ? _ctx.$t('button.create_workspace') : '',
        onClick: _ctx.createWorkspace
      }, null, 8, ["label", "onClick"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.searchKey,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKey = $event)),
            placeholder: _ctx.$t('label.search'),
            onInput: _ctx.load
          }, null, 8, ["modelValue", "placeholder", "onInput"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedOwner,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedOwner = $event)),
              options: _ctx.uniqueUsersOfWorkspace,
              placeholder: _ctx.$t('autots.overview.select.by.owner'),
              showClear: !!_ctx.selectedOwner
            }, {
              value: _withId((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.getFullname(slotProps.value)), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(slotProps.placeholder), 1))
              ]),
              option: _withId((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getFullname(slotProps.option)), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "placeholder", "showClear"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedTimeRange,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTimeRange = $event)),
              options: _ctx.timeRanges,
              placeholder: _ctx.$t('autots.overview.select.by.time')
            }, {
              value: _withId((slotProps) => [
                (slotProps && slotProps.value && slotProps.value.name)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.$t(slotProps.value.name)), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(slotProps.placeholder), 1))
              ]),
              option: _withId((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.$t(slotProps.option.name)), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "placeholder"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_DataTable, {
        value: _ctx.workspaces,
        selectionMode: "single",
        onRowSelect: _ctx.onRowSelect,
        onSort: _ctx.onSort,
        sortField: _ctx.dynamicSortField,
        sortOrder: _ctx.dynamicSortOrder,
        scrollable: true,
        scrollHeight: "flex"
      }, {
        footer: _withId(() => [
          (_ctx.hasMoreWorkspaces())
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('button.more'),
                  class: "p-button-text",
                  onClick: _ctx.loadMore
                }, null, 8, ["label", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.workspaces && _ctx.workspaces.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("workspace.list.table.empty")), 1))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('workspace.list.header.name'),
            sortable: true,
            headerClass: "name-column",
            bodyClass: "name-column"
          }, {
            body: _withId((slotProps) => [
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("span", null, [
                  _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    slotProps.data.desc,
                    void 0,
                    { right: true }
                  ]
                ])
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "createdBy",
            header: _ctx.$t('workspace.list.header.owner')
          }, {
            body: _withId((slotProps) => [
              _createVNode("div", null, _toDisplayString(_ctx.getFullname(slotProps.data.createdBy)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "createdDate",
            header: _ctx.$t('workspace.list.header.created'),
            sortable: true
          }, {
            body: _withId((slotProps) => [
              _withDirectives(_createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$moment(slotProps.data.createdDate).fromNow()), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$moment(slotProps.data.createdDate).format('LLLL'),
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "members",
            header: _ctx.$t('workspace.list.header.member')
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.userRoleList?.length), 1)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "onRowSelect", "onSort", "sortField", "sortOrder"])
    ]),
    _createVNode("div", _hoisted_18, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workspaces, (workspace) => {
        return (_openBlock(), _createBlock("div", {
          class: "p-col-12 p-md-6",
          key: workspace.id
        }, [
          _createVNode(_component_router_link, { to: '/workspace' }, {
            default: _withId(() => [
              _createVNode(_component_CardItem, {
                name: workspace.name,
                type: 'workspace',
                status: '',
                createdBy: workspace.createdBy,
                createdDate: workspace.createdDate
              }, null, 8, ["name", "createdBy", "createdDate"])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    (_ctx.displayCreateWorkspace)
      ? (_openBlock(), _createBlock(_component_EditWorkspace, {
          key: 0,
          onClicked: _ctx.offDialog
        }, null, 8, ["onClicked"]))
      : _createCommentVNode("", true)
  ], 64))
})